import { connect } from 'react-redux';
import actions from '../redux/actions/order_transaction';
import OrderTransactionHistoryComponent from '../components/OrderTransactionHistoryComponent';

const mapStateToProps = (state) => ({
  orderTrans: state.orderTrans,
  setting: state.setting,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchUserOrderTransactionsAction: (params, callback) => {
    dispatch(actions.fetchUserOrderTransactionsAction(params, callback));
  },
});

export const OrderTransactionHistoryContainer = connect(mapStateToProps, mapDispatchToProps)(OrderTransactionHistoryComponent);
